import { PageHelmet } from 'components/common/PageHelmet';
import { PatientLayout } from 'containers/PatientLayout';
import React from 'react';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import {
  FormTitle,
  LoginCard,
  LoginFormActions,
  LoginPartWrapper,
} from './LoginForm.styled';
import {
  CommonButton as Button,
  CommonLink,
} from '../../../common/Forms/Button';
import { LOGIN_URL } from '../../../../routes/AppRoutes';
import { useParams } from 'react-router';
import { Loading } from '../../../common/Loading';
import { useTrustSSOLogin } from '../../../../hooks/user/useTrustSSOLogin';

export const SSOLogin: React.FC = () => {
  const { t } = useCommonTranslation();

  const { trustId } = useParams<{
    trustId: string;
  }>();

  const { loginSAML, isLoading } = useTrustSSOLogin({ trustId });

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <PatientLayout graphics="unauth">
          <PageHelmet title={t('sso-login')} />
          <LoginCard>
            <LoginPartWrapper>
              <FormTitle>{t('sso-login-welcome')}</FormTitle>

              <LoginFormActions
                style={{
                  padding: 'var(--s3)',
                }}
              >
                <Button variant="primary" onClick={loginSAML} type="button">
                  {t('login-with-sso')}
                </Button>
                <CommonLink variant="secondary" to={LOGIN_URL} type="button">
                  {t('sso-back-to-standard-login')}
                </CommonLink>
              </LoginFormActions>
            </LoginPartWrapper>
          </LoginCard>
        </PatientLayout>
      )}
    </>
  );
};
